import ReturnType from './ReturnType';
import { getElement, outputTemplateMap } from './MultyElementsTemplate';
import { paginationCodeTemplate, paginationCodeLabel } from './PaginationTemplate';
import {
  advanceSelectLoopLabel,
  advanceSelectOuterLabel,
  advanceSelectTemplate,
  dispatchEventAdvanceSelectLabel
} from './SelectAdvance';

export default class ReturnMultipleType extends ReturnType {
  // out template use outputTemplateMap from MultyElementsTemplate
  outputTemplate = ({ attr, ...rest }) => {
    const args = { attr, advanceSelectLoopLabel, advanceSelectOuterLabel, ...rest };
    if (outputTemplateMap.has(this.returnAttributeType(attr)))
      return outputTemplateMap.get(this.returnAttributeType(attr))(args);
    if (outputTemplateMap.has(attr)) return outputTemplateMap.get(attr)(args);
    return outputTemplateMap.get('general')(args);
  };

  initChunkTemplate = () => 'let chunk = 1;';

  fillMap = (effectingArrayOfHtmlElements, dataName) =>
    `map.set(${effectingArrayOfHtmlElements}[i].getAttribute('id'), ${dataName}[${dataName}.length-i-1])`;

  // data name should be taken from the method
  responseForAllTemplate = (
    dataName,
    effectingArrayOfHtmlElements
  ) => `  ${dataName}.forEach((item,i) => {
    if(${effectingArrayOfHtmlElements}.length > i)
      {
        <subElementsManipulator>
        <fillMap>
        <insideForLoopTemplate>
      }
      ${dispatchEventAdvanceSelectLabel}
    });

    <storeMapInLocaleStorage>
    ${paginationCodeLabel}
    [...${effectingArrayOfHtmlElements}].forEach((element,index) => {if(index >= ${dataName}.length) ${effectingArrayOfHtmlElements}[index].style.display = 'none';})`;

  paginationCode = (dataName, effectingArrayOfHtmlElements, compId) =>
    paginationCodeTemplate(dataName, effectingArrayOfHtmlElements, compId);

  attributeArray = [];

  complexHtml;

  complexMethodId;

  complexHtmlElement;

  complexHtmlElementArray;

  elementTemplate;

  insideForLoopTemplate = '<insideForLoopTemplate>';

  insideForLoopHtmlElementName = 'insideSubDataElement';

  dataNameOfLoop = 'data';

  paginationList = false;

  compId = '';

  hasAdvanceSelect = false;

  advanceSelectElement = undefined;

  constructor(htmlDom, attributeArray, annotations, complexMethodId) {
    super(annotations);
    const upperHtmlElement = htmlDom.getElementById(complexMethodId);
    this.elementTemplate = getElement('general'); // getElement(upperHtmlElement?.tagName.toLowerCase());
    this.attributeArray = attributeArray || [];
    this.complexMethodId = complexMethodId;
    this.complexHtmlElement = htmlDom.getElementById(complexMethodId);
    this.complexHtmlElementArray = upperHtmlElement.querySelectorAll("[dataitem='true']") || [];

    if (upperHtmlElement.querySelector('[pagination-list="true"]')) {
      this.compId = complexMethodId;
      this.paginationList = true;
    }
    if (upperHtmlElement.querySelector('[advance-select]')) {
      this.hasAdvanceSelect = true;
      this.advanceSelectElement = upperHtmlElement.querySelector('[advance-select]');
    }
  }

  printFunctionality() {
    let js = '';
    if (!Object.keys(this.elementTemplate).length)
      return '/** not aplicable element has been selected */';

    js += this.elementTemplate.templateToGetSubElements(this.complexMethodId);

    js += this.newMapTemplate();
    if (
      this.complexHtmlElementArray[0] !== undefined &&
      this.complexHtmlElementArray[0].nodeName === 'OPTION'
    ) {
      js += this.addSelectOptions(this.dataNameOfLoop, this.elementTemplate.elementArrayName);
    }

    if (this.paginationList === true) {
      js += this.initChunkTemplate();
    }
    // this paste the for each method
    js += this.responseForAllTemplate(this.dataNameOfLoop, this.elementTemplate.elementArrayName);
    const uniqueQueries = new Set([...this.gatherComplexQueries(), ...this.gatherSimpleQueries()]);

    js = js.replace('<storeMapInLocaleStorage>', this.storeMapInLocalStorage);
    js = js.replace(
      '<fillMap>',
      this.fillMap(this.elementTemplate.elementArrayName, this.dataNameOfLoop)
    );

    const tryAndCatch = [...uniqueQueries]
      .map((queryCommand) => this.tryCatchTemplate(queryCommand))
      .reduce((acc, command) => acc + command, '');

    if (tryAndCatch !== '') {
      js = js.replace('<subElementsManipulator>', tryAndCatch);
    } else {
      js = js.replace(
        '<subElementsManipulator>',
        `console.log('There are no inside data elements');`
      );
    }

    if (this.paginationList === true) {
      js = js.replace(
        paginationCodeLabel,
        this.paginationCode(this.dataNameOfLoop, this.elementTemplate.elementArrayName, this.compId)
      );
    } else {
      js = js.replace(paginationCodeLabel, '');
    }

    if (this.hasAdvanceSelect === true) {
      js = js
        .replace(
          new RegExp(`${advanceSelectLoopLabel}`, 'g'),
          advanceSelectTemplate(
            this.insideForLoopHtmlElementName,
            `${this.dataNameOfLoop}[data.length -i -1]`,
            '_id'
          )
        )
        .replace(
          new RegExp(`${advanceSelectOuterLabel}`, 'g'),
          advanceSelectTemplate(
            `${this.elementTemplate.elementArrayName}[i]`,
            `${this.dataNameOfLoop}[data.length -i -1]`,
            '_id'
          )
        );
      js = js.replace(
        new RegExp(`${dispatchEventAdvanceSelectLabel}`, 'g'),
        `document.dispatchEvent(new Event("align${this.advanceSelectElement.getAttribute(
          'annotationname'
        )}"))`
      );
    } else {
      js = js.replace(
        new RegExp(
          `${advanceSelectLoopLabel}|${advanceSelectOuterLabel}|${dispatchEventAdvanceSelectLabel}`,
          'g'
        ),
        ''
      );
    }
    return js;
  }

  clearTemplate(stringToClear) {
    return stringToClear.replace(new RegExp(`${this.insideForLoopTemplate}`, 'g'), '');
  }
}
